import { Get, Put } from '../helpers';
import { TicketSetMember, PaidListsResponse } from '@/types/registration.types';

export const GetPaidLists = (channel: number): Promise<PaidListsResponse> => {
  return Get({
    path: `/v3/admin/paid-lists/${channel}`,
  });
};

export const GetPaidListMembers = (
  paidList: string,
  offset: number
): Promise<{ members: TicketSetMember[]; total: number | null }> => {
  return Get({
    path: `/v3/admin/paid-lists/members/${paidList}/${offset}`,
  });
};

export const SearchPaidListMembers = (paidList: string, offset: number, search: string): Promise<TicketSetMember[]> => {
  return Get({
    path: `/v3/admin/paid-lists/members/search/${paidList}/${offset}?search=${search}`,
  });
};

export const AddPaidListMember = (paidList: string, email: string): Promise<TicketSetMember> => {
  return Put({
    path: `/v3/admin/paid-lists/members/${paidList}`,
    body: { email },
  });
};

export const AddPaidListMemberMultiple = (
  paidList: string,
  url: string
): Promise<{ added: number; invalid: string[] }> => {
  return Put({
    path: `/v3/admin/paid-lists/members/multiple/${paidList}`,
    body: { url },
  });
};
